// extracted by mini-css-extract-plugin
export default {"game-end-info":"GameEndInfo_game-end-info__yM0A4","game-end-info__buttons":"GameEndInfo_game-end-info__buttons__WM601"};